var engine = require('../src/store-engine')

var storages = require('../storages/all')
var plugins = [require('../plugins/json2')]

module.exports = engine.createStore(storages, plugins)



//////////////////
// WEBPACK FOOTER
// /Users/yinminpan/Local Dev/business-events-tas/wp-content/themes/b-e-tas/node_modules/store/dist/store.legacy.js
// module id = 77
// module chunks = 0